import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/MarkdownRenderer/MarkdownRenderer.tsx");
